import { Auth } from '@entities/user'
import { createApi } from '@reduxjs/toolkit/query/react'
import { backendBaseQuery } from '@shared/api'

export interface LoginPayload {
  userPlatformId: string
  pin: string
}
// Define a service using a base URL and expected endpoints
export const authLoginApi = createApi({
  reducerPath: 'auth-login',
  baseQuery: backendBaseQuery,
  tagTypes: [
    'Auth',
    'User'
  ],
  endpoints: (build) => ({
    login: build.mutation<Auth, LoginPayload>({
      query: (body) => ({
        url: `auth/login`, 
        method: 'POST',
        body
      }),
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useLoginMutation } = authLoginApi